export default "__VITE_ASSET__e1725f51__"